export default __webpack_public_path__ + "static/media/transiluminator-caution.7ef1c3af.svg";